import { render } from "./InterviewDetail.vue?vue&type=template&id=36454cb2&scoped=true"
import script from "./InterviewDetail.vue?vue&type=script&lang=js"
export * from "./InterviewDetail.vue?vue&type=script&lang=js"

import "./InterviewDetail.vue?vue&type=style&index=0&id=36454cb2&scoped=true&lang=css"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36454cb2"]])

export default __exports__